/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionType } from './CompetitionType';
import {
    CompetitionTypeFromJSON,
    CompetitionTypeFromJSONTyped,
    CompetitionTypeToJSON,
    CompetitionTypeToJSONTyped,
} from './CompetitionType';

/**
 * 
 * @export
 * @interface CreateCompetitionBodyItemsInner
 */
export interface CreateCompetitionBodyItemsInner {
    /**
     * 
     * @type {CompetitionType}
     * @memberof CreateCompetitionBodyItemsInner
     */
    type?: CompetitionType;
    /**
     * 
     * @type {CompetitionType}
     * @memberof CreateCompetitionBodyItemsInner
     */
    subtype?: CompetitionType;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBodyItemsInner
     */
    refId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBodyItemsInner
     */
    division?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCompetitionBodyItemsInner
     */
    order?: number;
}



/**
 * Check if a given object implements the CreateCompetitionBodyItemsInner interface.
 */
export function instanceOfCreateCompetitionBodyItemsInner(value: object): value is CreateCompetitionBodyItemsInner {
    return true;
}

export function CreateCompetitionBodyItemsInnerFromJSON(json: any): CreateCompetitionBodyItemsInner {
    return CreateCompetitionBodyItemsInnerFromJSONTyped(json, false);
}

export function CreateCompetitionBodyItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompetitionBodyItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : CompetitionTypeFromJSON(json['type']),
        'subtype': json['subtype'] == null ? undefined : CompetitionTypeFromJSON(json['subtype']),
        'refId': json['refId'] == null ? undefined : json['refId'],
        'division': json['division'] == null ? undefined : json['division'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function CreateCompetitionBodyItemsInnerToJSON(json: any): CreateCompetitionBodyItemsInner {
    return CreateCompetitionBodyItemsInnerToJSONTyped(json, false);
}

export function CreateCompetitionBodyItemsInnerToJSONTyped(value?: CreateCompetitionBodyItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': CompetitionTypeToJSON(value['type']),
        'subtype': CompetitionTypeToJSON(value['subtype']),
        'refId': value['refId'],
        'division': value['division'],
        'order': value['order'],
    };
}

